import moment from 'moment'
import { lang } from '@/locale'

export default {
  data() {
    return {
      postDate: null,
      schedule: false,
    }
  },
  computed: {
    schedulePostDate() {
      if (this.parentPost && this.parentPost.ScheduledDate && this.parentPost.ScheduledDate !== 'NULL') {
        return moment(this.parentPost.ScheduledDate).format('DD/MM/YYYY HH:mm')
      }
      return this.parentPost ? this.parentPost.PostCreatedDate_convert : ''
    },
    isSchedulePosted() {
      const post = this.parentPost
      if (!post || post.PostStatus !== 'Approved') return false
      const noScheduledDate = !post.ScheduledDate || post.ScheduledDate === 'NULL'
      // No schedule means it is already out; otherwise it is only "Posted"
      // once the scheduled date has arrived. A future date is still pending.
      return noScheduledDate || moment(post.ScheduledDate).isSameOrBefore(moment())
    },
    schedulePostStatusLabel() {
      if (!this.parentPost) return ''
      return this.isSchedulePosted ? `(${lang('Post Posted')})` : `(${lang('Post Pending')})`
    },
  },
  methods: {
    initScheduleDate(post) {
      if (!this.postDate && post.ScheduledDate && post.ScheduledDate !== 'NULL') {
        this.postDate = moment(post.ScheduledDate).toDate()
      }
    },
    handleSchedule(status) {
      if (status) {
        this.schedule = status
      } else {
        this.schedule = !this.schedule
      }
    },
  },
}
